<button *ngIf="(canScrollLeft | async)" class="scroll-button ms-1" (click)="scrollLeft()">&lt;</button>
<div class="navbar-nav d-flex flex-nowrap align-items-center mt-2 mb-2 scroll-container" #filtersContainer>
  <div *ngFor="let headerFilter of (headerFilters | async)"
       class="nav-item"
       id="{{'header-filter-' + headerFilter.id}}">
    <asax-header-filter *ngIf="headerFilter?.valueToDisplay?.length > 0"
                        [headerFilter]="headerFilter"
                        (outHeaderFilter)="onHeaderFilter($event)"
                        (outRemoveHeaderFilter)="onRemoveHeaderFilter($event)">
    </asax-header-filter>
  </div>
  <div *ngIf="displayClearAllHeaderFilters" class="nav-item">
    <button class="btn btn-sm btn-primary me-1" (click)="removeHeaderFilters()" placement="bottom" ngbTooltip="Remove all filters">
      <i class="fa fa-times"></i>
    </button>
  </div>
  <div *ngIf="validColumnsFiltersForActiveTab?.length > 0" class="nav-item ps-1">
    <small class="d-inline-flex px-2 py-1 fw-semibold text-white bg-info bg-opacity-10 border border-success border-opacity-10 rounded-2">
      <ng-container [ngPlural]="validColumnsFiltersForActiveTab?.length">
        <ng-template ngPluralCase="=1">
          {{validColumnsFiltersForActiveTab?.length}} column filter active
        </ng-template>
        <ng-template ngPluralCase="other">
          {{validColumnsFiltersForActiveTab?.length}} column filters active
        </ng-template>
      </ng-container>
    </small>
  </div>
</div>
<button *ngIf="(canScrollRight | async)" class="scroll-button" (click)="scrollRight()">&gt;</button>
